import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useDataContext } from "context";
import { QueryKeys, client } from "queryClient";
import { Expansion } from "types";
import { getExpansionName } from "modules/expansions/business";

type ExpansionReadParamsType = {
  expansionID: string;
};

export const useExpansionRead = () => {
  const dataContext = useDataContext();

  const { expansionID } = useParams<ExpansionReadParamsType>();

  console.log("Loading expansion with ID: ", expansionID);

  const { data: expansion, isLoading } = useQuery({
    queryKey: [QueryKeys.Expansions, { id: expansionID }],
    queryFn: async () => {
      if (!expansionID) return null;

      const expansionResponse = await client.models.Expansion.get({
        id: expansionID,
      });

      const expansionFromAPI = expansionResponse.data;

      if (expansionFromAPI) {
        dataContext.setCurrentData({
          id: expansionFromAPI.id,
          name: getExpansionName(expansionFromAPI),
        });

        if (!dataContext.expansion) {
          dataContext.setExpansion(expansionFromAPI);
        }
      }

      return expansionFromAPI ? (expansionFromAPI as Expansion) : null;
    },
  });

  return {
    expansionID,
    expansion: expansion ?? null,
    isLoading,
  };
};
